export const decideTab = (isLoggedIn, isAccommodationProvider, defaultTabs, apTabs, guestTabs) => {
  if (!isLoggedIn) {
    return defaultTabs;
  }

  return isAccommodationProvider ? apTabs : guestTabs;
};
